import React from 'react'
import SearchTemplate from '../components/Blog/SearchTemplate'
import { config } from '../config/config'

function SearchPage() {
    return (
        <div>
            <SearchTemplate searchUrl={config.api_base_url + "/wp-json/wp/v2/posts?_embed&search="} searchPlaceholder="Search posts" />
        </div>
    )
}
export default SearchPage